import { createIcon, Icon, IconProps } from '@chakra-ui/react';

export const CheckIconVoucher = (props: IconProps) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_9700_247814"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9700_247814)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.15658 16.1797C2.48296 16.5061 2.87533 16.6693 3.33366 16.6693H16.667C17.1253 16.6693 17.5177 16.5061 17.8441 16.1797C18.1705 15.8533 18.3337 15.4609 18.3337 15.0026V12.1901C18.3337 12.0373 18.285 11.9054 18.1878 11.7943C18.0906 11.6832 17.9656 11.6137 17.8128 11.5859C17.4795 11.4748 17.2052 11.2734 16.9899 10.9818C16.7746 10.6901 16.667 10.3637 16.667 10.0026C16.667 9.64149 16.7746 9.3151 16.9899 9.02344C17.2052 8.73177 17.4795 8.53038 17.8128 8.41927C17.9656 8.39149 18.0906 8.32205 18.1878 8.21094C18.285 8.09983 18.3337 7.96788 18.3337 7.8151V5.0026C18.3337 4.54427 18.1705 4.15191 17.8441 3.82552C17.5177 3.49913 17.1253 3.33594 16.667 3.33594H3.33366C2.87533 3.33594 2.48296 3.49913 2.15658 3.82552C1.83019 4.15191 1.66699 4.54427 1.66699 5.0026V7.8151C1.66699 7.96788 1.7156 8.09983 1.81283 8.21094C1.91005 8.32205 2.03505 8.39149 2.18783 8.41927C2.52116 8.53038 2.79546 8.73177 3.01074 9.02344C3.22602 9.3151 3.33366 9.64149 3.33366 10.0026C3.33366 10.3637 3.22602 10.6901 3.01074 10.9818C2.79546 11.2734 2.52116 11.4748 2.18783 11.5859C2.03505 11.6137 1.91005 11.6832 1.81283 11.7943C1.7156 11.9054 1.66699 12.0373 1.66699 12.1901V15.0026C1.66699 15.4609 1.83019 15.8533 2.15658 16.1797ZM13.5545 6.53975L8.63786 11.4564L7.05452 9.87309C6.90175 9.72031 6.7073 9.64392 6.47119 9.64392C6.23508 9.64392 6.04064 9.72031 5.88786 9.87309C5.73508 10.0259 5.65869 10.2203 5.65869 10.4564C5.65869 10.6925 5.73508 10.887 5.88786 11.0398L8.05452 13.2064C8.22119 13.3731 8.41564 13.4564 8.63786 13.4564C8.86008 13.4564 9.05452 13.3731 9.22119 13.2064L14.7212 7.70642C14.874 7.55364 14.9504 7.3592 14.9504 7.12309C14.9504 6.88698 14.874 6.69253 14.7212 6.53975C14.5684 6.38698 14.374 6.31059 14.1379 6.31059C13.9017 6.31059 13.7073 6.38698 13.5545 6.53975Z"
          fill="#34C759"
        />
      </g>
    </Icon>
  );
};
